import { defineMessages } from "react-intl";

const messages = defineMessages({
    lookUp: {
        id: "embed.lookUp",
    },
});

export default messages;
